// import { $view } from 'signals/global.signals';

import { getOrgDocuments } from 'api/documents.api';
import { getOrgFinancialMetrics } from 'api/metrics.api';
import { getOrgFolders } from 'api/folders.api';
import { $user, $form, $view } from 'signals/global.signals';
import mergeDocumentsAndFolders from 'utils/mergeFilesAndFolders';

export const fetchAndSetDealOptions = async () => {
  try {
    const [{ data: metrics }, { data: folders }, { data: documents }] = await Promise.all([
      getOrgFinancialMetrics(),
      getOrgFolders(),
      getOrgDocuments(),
    ]);

    const mergedFolders = mergeDocumentsAndFolders(documents, folders);
    $form.update({
      name: `${$user.value.organization.name} - Fund Raise`,
      isMrrIncluded: true,
      isArrIncluded: true,
      isCashOnHandIncluded: true,
      isInvestmentsIncluded: true,
      isLiabilitiesIncluded: true,
      postMoneyValuation: metrics.postMoneyValuation,
      amountPreviouslyRaised: metrics.amountPreviouslyRaised || 0,
      dataVaultInclusion: 'all',
    });
    $view.update({
      folders: mergedFolders,
    });
  } catch (error) {
    console.error(error);
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};
